<template>
  <div>
    CostCenterPage
  </div>
</template>

<script>
export default {
  name: 'CostCenterPage'
}
</script>

<style lang="scss" scoped>
</style>
